import { render, staticRenderFns } from "./GoodAtrrtag.vue?vue&type=template&id=ff67edac&"
import script from "./GoodAtrrtag.vue?vue&type=script&lang=js&"
export * from "./GoodAtrrtag.vue?vue&type=script&lang=js&"
import style0 from "./GoodAtrrtag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports